import {
    ExternalFinancialEntity,
    getCurrentValue,
} from '../../financialEntities';
import { sortBy } from '../../util/arrays';
import { groupByWithTotal } from '../../util/objects';

export const orderAccountsByBalancePerInstitution = (
    accounts: ExternalFinancialEntity[],
    type: 'asset' | 'debt'
) => {
    const accountsByInstitution = groupByWithTotal(
        accounts,
        (a) => a.institution?.name || 'unknown',
        (a) => getCurrentValue(a, { useNegativeForDebts: true }) || 0
    );
    // convert from object structure to array and sort by institution totals
    const accountsByInstitutionArr = sortBy(
        Object.values(accountsByInstitution),
        (i) => i.total,
        type === 'asset' ? 'DESC' : 'ASC'
    );

    return accountsByInstitutionArr.flatMap((institution) =>
        sortBy(
            institution.items,
            (a) => getCurrentValue(a, { useNegativeForDebts: true }) || 0,
            type === 'asset' ? 'DESC' : 'ASC'
        )
    );
};
